var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhiteClose24Px({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "close-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M18,6h0a.967.967,0,0,0-1.4,0L12,10.6,7.4,6A.967.967,0,0,0,6,6H6A.967.967,0,0,0,6,7.4L10.6,12,6,16.6A.967.967,0,0,0,6,18H6a.967.967,0,0,0,1.4,0L12,13.4,16.6,18A.967.967,0,0,0,18,18h0a.967.967,0,0,0,0-1.4L13.4,12,18,7.4A.967.967,0,0,0,18,6Z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteClose24Px);
export default __webpack_public_path__ + "static/media/white-close-24px.3ef39b9211720c2ae71fe593558ecd91.svg";
export { ForwardRef as ReactComponent };